import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Translations
import menu from './components/menu';
import login from './pages/login';
import departments from './pages/departments';
import words from './global';
import errors from './errors';
import entities from './entities';
import agents from './pages/agents';
import datepicker from './components/datepicker';
import metrics from './components/metrics';
import calls from './pages/calls';
import help_center from './components/help_center';
import integration from './pages/integration';
import password_reset from './pages/password-reset';
import widget from './components/widget';
import accounts from './pages/accounts';

Vue.use(VueI18n);

const messages = {
  en: {
    menu: menu.en,
    login: login.en,
    departments: departments.en,
    words: words.en,
    errors: errors.en,
    entities: entities.en,
    agents: agents.en,
    datepicker: datepicker.en,
    metrics: metrics.en,
    calls: calls.en,
    help_center: help_center.en,
    integration: integration.en,
    password_reset: password_reset.en,
    widget: widget.en,
    accounts: accounts.en,
  },
  es: {
    menu: menu.es,
    login: login.es,
    departments: departments.es,
    words: words.es,
    errors: errors.es,
    entities: entities.es,
    agents: agents.es,
    datepicker: datepicker.es,
    metrics: metrics.es,
    calls: calls.es,
    help_center: help_center.es,
    integration: integration.es,
    password_reset: password_reset.es,
    widget: widget.es,
    accounts: accounts.es,
  },
};

const i18n = new VueI18n({
  locale: (window.navigator.language) && window.navigator.language.split('-')[0], // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
});

export default i18n;
